exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect{min-width:15rem!important;margin:0 2%}.multiselect__tags{min-height:48px;padding-top:12px}.multiselect__option--highlight{background:#0080fc}.multiselect__option--selected.multiselect__option--highlight{background:#707070}.multiselect--above .multiselect__content-wrapper{bottom:auto!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-98c35aec","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./resources/office/js/components/dashboard-v5/lib/dv5-multiselect.vue
// module id = ld8d
// module chunks = 0